import { UnsupportedTokenVersionError } from './types'
import type { SessionStrategy } from './types'
import { createTokenV1V2Strategy } from './websocket/strategies/token-v1v2'
import { createTokenV3Strategy } from './websocket/strategies/token-v3'
import { createEngineV2Strategy } from './engine-v2/strategy'
import type { TokenDecoded } from '@/composables/workflow/useWorkflow'

type EngineType = NonNullable<TokenDecoded['engineType']>

const STRATEGIES: Partial<Record<number, Partial<Record<EngineType, () => SessionStrategy>>>> = {
    1: { ORCHESTRATOR: createTokenV1V2Strategy },
    2: { ORCHESTRATOR: createTokenV1V2Strategy },
    3: { ORCHESTRATOR: createTokenV3Strategy, WORKFLOW_EXECUTOR: createEngineV2Strategy },
}

export const resolveStrategy = (version: unknown, engineType?: TokenDecoded['engineType']): SessionStrategy => {
    // object keys are strings, so a lookup with a string version would hit a numeric entry
    if (typeof version !== 'number' || !Number.isInteger(version)) {
        throw new UnsupportedTokenVersionError(version)
    }

    const factory = STRATEGIES[version]?.[engineType ?? 'ORCHESTRATOR']

    if (!factory) {
        throw new UnsupportedTokenVersionError(version)
    }

    return factory()
}
